<template>
	<div>
		<div class="wrap_page" style="margin-bottom: 15px">
			<div class="flex flex-center tabs">
				<el-steps
					:active="active"
					finish-status="success"
					style="width:100%;"
					class="stepss"
				>
					<el-step title="项目信息" @click.native="on_active_1"></el-step>
					<el-step title="人员信息" @click.native="on_active_2"></el-step>
					<el-step title="薪资信息" @click.native="on_active_3"></el-step>
					<el-step title="考勤信息" @click.native="on_active_4"></el-step>
					<el-step title="财务信息" @click.native="on_active_5"></el-step>
					<el-step title="辅助账" @click.native="on_active_6"></el-step>
					<el-step title="其他备查资料" @click.native="on_active_7"></el-step>
				</el-steps>
			</div>
		</div>
		<personnel v-if="active === 0" @ok="on_active_2"></personnel>
		<personalInformation v-if="active === 1"></personalInformation>
		<salaryInformation v-if="active === 2"></salaryInformation>
		<clockingin v-if="active === 3"></clockingin>
		<finance v-if="active === 4"></finance>
		<auxiliary v-if="active === 5"></auxiliary>
		<otherdetails v-if="active === 6"></otherdetails>
	</div>
</template>

<script>
import personnel from "./modules/personnel";
import personalInformation from "./modules/personalInformation";
import salaryInformation from "./modules/SalaryInformation";
import clockingin from "./modules/clockingin";
import finance from "./modules/finance";
import auxiliary from "./modules/auxiliary";
import otherdetails from "./modules/otherdetails";

export default {
	data() {
		return {
			activeIndex: "",
			active: 0
		};
	},
	created() {
		if (sessionStorage.getItem("zt_jjkc_jump") == 1) {
			this.on_active_7();
			sessionStorage.setItem("zt_jjkc_jump", "");
		}
	},
	methods: {
		on_active_1() {
			if (this.active == 0) {
				this.$confirm(
					"请确认当前页数据是否填写完整并保存,否则将导致数据丢失(若已保存请忽略)",
					"确认离开吗?",
					{ type: "warning" }
				).then(() => {
					this.active = 0;
				});
			} else {
				this.active = 0;
			}
		},
		on_active_2() {
			if (!sessionStorage.getItem("zt_jjkc_project_id")) {
				this.$message.error("请先填写并保存基本信息");
			} else {
				if (this.active == 0) {
					this.$confirm(
						"请确认当前页数据是否填写完整并保存,否则将导致数据丢失(若已保存请忽略)",
						"确认离开吗?",
						{ type: "warning" }
					).then(() => {
						this.active = 1;
					});
				} else {
					this.active = 1;
				}
			}
		},
		on_active_3() {
			if (!sessionStorage.getItem("zt_jjkc_project_id")) {
				this.$message.error("请先填写并保存基本信息");
			} else {
				if (this.active == 0) {
					this.$confirm(
						"请确认当前页数据是否填写完整并保存,否则将导致数据丢失(若已保存请忽略)",
						"确认离开吗?",
						{ type: "warning" }
					).then(() => {
						this.active = 2;
					});
				} else {
					this.active = 2;
				}
			}
		},
		on_active_4() {
			if (!sessionStorage.getItem("zt_jjkc_project_id")) {
				this.$message.error("请先填写并保存基本信息");
			} else {
				if (this.active == 0) {
					this.$confirm(
						"请确认当前页数据是否填写完整并保存,否则将导致数据丢失(若已保存请忽略)",
						"确认离开吗?",
						{ type: "warning" }
					).then(() => {
						this.active = 3;
					});
				} else {
					this.active = 3;
				}
			}
		},
		on_active_5() {
			if (!sessionStorage.getItem("zt_jjkc_project_id")) {
				this.$message.error("请先填写并保存基本信息");
			} else {
				if (this.active == 0) {
					this.$confirm(
						"请确认当前页数据是否填写完整并保存,否则将导致数据丢失(若已保存请忽略)",
						"确认离开吗?",
						{ type: "warning" }
					).then(() => {
						this.active = 4;
					});
				} else {
					this.active = 4;
				}
			}
		},
		on_active_6() {
			if (!sessionStorage.getItem("zt_jjkc_project_id")) {
				this.$message.error("请先填写并保存基本信息");
			} else {
				if (this.active == 0) {
					this.$confirm(
						"请确认当前页数据是否填写完整并保存,否则将导致数据丢失(若已保存请忽略)",
						"确认离开吗?",
						{ type: "warning" }
					).then(() => {
						this.active = 5;
					});
				} else {
					400;
					this.active = 5;
				}
			}
		},
		on_active_7() {
			if (!sessionStorage.getItem("zt_jjkc_project_id")) {
				this.$message.error("请先填写并保存基本信息");
			} else {
				if (this.active == 0) {
					this.$confirm(
						"请确认当前页数据是否填写完整并保存,否则将导致数据丢失(若已保存请忽略)",
						"确认离开吗?",
						{ type: "warning" }
					).then(() => {
						this.active = 6;
					});
				} else {
					this.active = 6;
				}
			}
		}
	},
	components: {
		personnel,
		personalInformation,
		salaryInformation,
		clockingin,
		finance,
		auxiliary,
		otherdetails
	}
};
</script>
<style scoped>
.text {
	font-size: 14px;
	padding: 10px 20px;
	position: relative;
	border-bottom: 1px solid #dbdbdb;
	margin-bottom: 20px;
}
.text::before {
	content: "";
	position: absolute;
	width: 4px;
	height: 18px;
	left: 10px;
	top: 10px;
	background: #7c99fd;
}
</style>
